import { render, staticRenderFns } from "./NewsSectionDataList.vue?vue&type=template&id=563042d8&scoped=true&"
import script from "./NewsSectionDataList.vue?vue&type=script&lang=js&"
export * from "./NewsSectionDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563042d8",
  null
  
)

export default component.exports